module.exports = __webpack_public_path__ + "img/promo-individuelles@1x.6b479063.png";